import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import {
    DatiqInputErrorTypes,
    IDatiqInputValidatorService,
    IDatiqInput,
} from '@dat/datiq-components-pkg/utils';
import { DatiqDatepickerValidators } from '../validators';

@Injectable({
    providedIn: 'root',
})
export class DatiqDatepickerValidatorDatemaxService
    implements IDatiqInputValidatorService
{
    constructor() {}

    addValidator(
        settings: IDatiqInput,
        validators: ValidatorFn[]
    ): ValidatorFn[] {
        return !!settings?.[DatiqInputErrorTypes.DateMax]
            ? [
                  ...validators,
                  DatiqDatepickerValidators.maxDate(
                      settings?.[DatiqInputErrorTypes.DateMax]
                  ),
              ]
            : [...validators];
    }
}
